import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "hiddenField"]

  submitForm(event) {
    const selectedAttributes = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => JSON.parse(checkbox.dataset.attribute))

    if (selectedAttributes.length === 0) {
      event.preventDefault()
      alert("Please select at least one attribute to add.")
      return
    }

    this.hiddenFieldTarget.value = JSON.stringify(selectedAttributes)
  }
}
